export enum SUBDOMAIN_ENUM {
  BINDEMY = 'BINDEMY',
  SEDI = 'SEDI',
  MARTINBUCER = 'MARTINBUCER',
    INSTITUTOANTIOQUIA = 'INSTITUTOANTIOQUIA',
       ESCOLADAVELOCIDADE = 'ESCOLADAVELOCIDADE',
  RAIZDAQUESTAO = 'RAIZDAQUESTAO',
  ESCOLAIMPULSE = 'ESCOLAIMPULSE',
  XLR8ACADEMY = 'XLR8ACADEMY',
  PROPAGA = 'PROPAGA',
  POLOSUNIP = 'POLOSUNIP',
  CURSO = 'CURSO',
  CGA = 'CGA',
  IGREJABASE = 'IGREJABASE',
  SBPV = 'SBPV',
  SETEPEBCARUARU = 'SETEPEBCARUARU',
}

